export const getWorkshopAlerts = (status) => {
  const alerts = [];

  const stuck = status?.stuck ?? 0;
  const waitingParts = status?.waitingParts ?? 0;
  const waitingClient = status?.waitingClient ?? 0;
  const outsideOverdue = status?.outsideOverdue ?? 0;
  const rma = status?.rma ?? 0;

  
  if (stuck >= 5) alerts.push("Priorizar reparaciones atascadas");

  if (waitingParts > 5) {
    alerts.push("Posible retraso de repuestos, contacta con proveedor");
  } else if (waitingParts >= 3) {
    alerts.push("Buen momento para hacer pedido");
  }

  if (waitingClient >= 5) alerts.push("Contactar con clientes pendientes de confirmación");

  if (outsideOverdue > 0) alerts.push("Revisa estado reparaciones enviadas al exterior");

  if (rma > 5) alerts.push("Priorizar reparaciones RMA");

  if (alerts.length === 0) alerts.push("Flujo de trabajo estable");

  return alerts;
};